import { FC, ReactNode, useState } from 'react';
import { Box, Typography, Svg, Card } from '@altermaind/web/ui';

type Props = {
  code: string;
  children: ReactNode;
};

export const ComponentShowcase: FC<Props> = ({ code, children }) => {
  const [isCodeVisible, setIsCodeVisible] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch {
      // fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    }
  };

  const toggleCode = () => {
    setIsCodeVisible(!isCodeVisible);
  };

  return (
    <Card py='none' px='none' pt='s' pb='xs'>
      <Box mb='xs'>{children}</Box>

      <Box display='flex' alignItems='center' style={{ gap: '8px' }}>
        <Box
          onClick={toggleCode}
          display='flex'
          alignItems='center'
          style={{ cursor: 'pointer', gap: '4px' }}
        >
          <Typography variant='p2' color='primary'>
            {isCodeVisible ? 'Hide Code - ' : 'Show Code - '}
          </Typography>
        </Box>

        <Box
          onClick={handleCopy}
          display='flex'
          alignItems='center'
          style={{ cursor: 'pointer', gap: '4px' }}
        >
          <Svg fill='primary' name={isCopied ? 'check' : 'copy'} size='xs' />
          <Typography variant='p2' color={isCopied ? 'success' : 'primary'}>
            {isCopied ? 'Copied!' : 'Copy'}
          </Typography>
        </Box>
      </Box>

      <Box
        style={{
          display: 'grid',
          gridTemplateRows: isCodeVisible ? '1fr' : '0fr',
          transition: 'grid-template-rows 0.3s ease',
        }}
      >
        <Box style={{ overflow: 'hidden' }}>
          <Box
            mt='s'
            p='s'
            style={{
              backgroundColor: '#1e1e1e',
              borderRadius: '8px',
              overflow: 'auto',
            }}
          >
            <pre style={{ margin: 0, color: '#d4d4d4', fontSize: '13px', fontFamily: 'monospace' }}>
              <code>{code}</code>
            </pre>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
